import React from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { TableCell, TableRow } from '../ui/table';
import { UserCheck, XCircle } from 'lucide-react';

export const MOTIVOS = {
  SIN_CUIT: { label: 'Sin CUIT', clase: 'bg-slate-100 text-slate-700 border-slate-200' },
  CUIT_INVALIDO: { label: 'CUIT inválido', clase: 'bg-amber-50 text-amber-800 border-amber-200' },
  CUIT_CONFLICTO: { label: 'CUIT distinto al padrón', clase: 'bg-red-50 text-red-700 border-red-200' },
};
const ESTADOS = {
  PENDIENTE: 'bg-blue-50 text-blue-700 border-blue-200',
  ASIGNADA: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  DESCARTADA: 'bg-slate-100 text-slate-500 border-slate-200',
};

const fecha = (v) => (v ? String(v).slice(0, 16).replace('T', ' ') : '—');
const pesos = (v) => `$${Number(v || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 })}`;

const Resolucion = ({ c }) => (
  <div className="space-y-0.5">
    <Badge variant="outline" className={`text-[11px] ${ESTADOS[c.estado] || ''}`} data-testid={`csi-estado-${c.cvu}`}>{c.estado}</Badge>
    {c.asignado_a_cuit && <p className="text-[11px] text-slate-500 font-mono">→ {c.asignado_a_cuit}</p>}
    {c.motivo_descarte && <p className="text-[11px] text-slate-500 max-w-[180px] truncate" title={c.motivo_descarte}>{c.motivo_descarte}</p>}
  </div>
);

// Fila de la tabla de Cuentas sin identificar.
export const CuentaSinIdentificarFila = ({ c, puedeActuar, onAsignar, onDescartar }) => {
  const m = MOTIVOS[c.motivo] || { label: c.motivo, clase: '' };
  return (
    <TableRow className="hover:bg-slate-50 transition-colors" data-testid={`csi-row-${c.cvu}`}>
      <TableCell className="font-mono text-xs text-slate-900">{c.cvu}
        {c.nombre_detectado && <p className="font-sans text-[11px] text-slate-500 mt-0.5">{c.nombre_detectado}</p>}
      </TableCell>
      <TableCell className="text-sm text-slate-700">{c.banco_sponsor || '—'}</TableCell>
      <TableCell><Badge variant="outline" className={`text-[11px] ${m.clase}`}>{m.label}</Badge></TableCell>
      <TableCell className="font-mono text-xs text-slate-700">{c.cuit_detectado || '—'}
        {c.cuit_en_padron && <p className="font-sans text-[11px] text-red-600">padrón: <span className="font-mono">{c.cuit_en_padron}</span></p>}
      </TableCell>
      <TableCell className="text-xs text-slate-600 whitespace-nowrap">{fecha(c.primer_movimiento)}</TableCell>
      <TableCell className="text-xs text-slate-600 whitespace-nowrap">{fecha(c.ultimo_movimiento)}</TableCell>
      <TableCell className="text-right text-sm tabular-nums">{c.cantidad ?? 0}</TableCell>
      <TableCell className="text-right text-sm tabular-nums whitespace-nowrap">{pesos(c.volumen)}</TableCell>
      <TableCell className="text-center">
        <span className={`inline-flex min-w-[28px] justify-center rounded-full px-2 py-0.5 text-xs font-semibold ${
          c.alertas_en_espera ? 'bg-orange-100 text-orange-700' : 'bg-slate-100 text-slate-400'}`} data-testid={`csi-espera-${c.cvu}`}>
          {c.alertas_en_espera || 0}
        </span>
      </TableCell>
      <TableCell>
        {c.estado === 'PENDIENTE' && puedeActuar ? (
          <div className="flex gap-1.5 justify-end">
            <Button size="sm" variant="outline" onClick={() => onAsignar(c)} className="h-8 text-blue-700 border-blue-200 hover:bg-blue-50"
              data-testid={`csi-asignar-${c.cvu}`}><UserCheck size={14} className="mr-1" /> Asignar a CUIT</Button>
            <Button size="sm" variant="ghost" onClick={() => onDescartar(c)} className="h-8 text-rose-600 hover:bg-rose-50"
              data-testid={`csi-descartar-${c.cvu}`}><XCircle size={14} className="mr-1" /> Descartar</Button>
          </div>
        ) : <Resolucion c={c} />}
      </TableCell>
    </TableRow>
  );
};
